import {
  allKeysHaveValues,
  distinct
} from "../../../../../helpers/JSONTransformations";

import { trim } from "../../../../../helpers/StringManipulation";

export const checkAllVariantFieldsHaveValues = (
  rows,
  setAllVariantFieldsHaveValues
) => {
  const allVariantFieldsHaveValues = rows.every((row) => {
    const rowWithoutStock = (({ stock, ...row }) => row)(row);
    return allKeysHaveValues(rowWithoutStock);
  });

  setAllVariantFieldsHaveValues(allVariantFieldsHaveValues);

  return allVariantFieldsHaveValues;
};

export const findDuplicateSkuRowIndicies = (
  rows,
  setDuplicateSkuRowIndicies
) => {
  const duplicateSkuRowIndicies = distinct(
    rows.map(
      (row, index) =>
        rows.filter((otherRow) => trim(row.sku) === trim(otherRow.sku)).length >
          1 && index
    )
  ).filter((i) => i !== false);

  setDuplicateSkuRowIndicies(duplicateSkuRowIndicies);

  return duplicateSkuRowIndicies;
};

export const findDuplicateOptionsRowIndicies = (
  rows,
  setDuplicateOptionsRowIndices
) => {
  const duplicateOptionsRowIndicies = distinct(
    rows
      .map((row, index) => {
        const variantOptions = (({
          id,
          sku,
          price,
          stock,
          ...variantOptions
        }) => variantOptions)(row);

        const rowsThatHaveTheDuplicateVariantOptions = rows.filter((row) =>
          Object.keys(variantOptions).every(
            (variantOptionKey) =>
              trim(row[variantOptionKey]) ===
              trim(variantOptions[variantOptionKey])
          )
        );

        return rowsThatHaveTheDuplicateVariantOptions.length > 1 && index;
      })
      .filter((i) => i !== false)
  );

  setDuplicateOptionsRowIndices(duplicateOptionsRowIndicies);

  return duplicateOptionsRowIndicies;
};

export const checkAllVariantPrices = (
  rows,
  setFormHasAnInvalidPrice,
  minimumPrice
) => {
  const invalidPrices = rows.filter((row) => {
    return minimumPrice > row.price
  });

  const formHasAnInvalidPrice = !!invalidPrices.length;
  setFormHasAnInvalidPrice(formHasAnInvalidPrice);
  return formHasAnInvalidPrice
};
